/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { Show } from '@atlaskit/primitives/responsive';

import { BlogBanner, BlogHeader, type BlogMeta, MDXBlogRenderer } from '../src/blog';
import { HeadingContextProvider } from '../src/heading-context';
import { LocalNav } from '../src/local-nav';

const pageContainerStyles = xcss({ maxWidth: '1280px' });
const contentContainerStyles = xcss({
	width: '100%',
	display: 'flex',
	justifyContent: 'center',
	paddingBlockEnd: 'space.600',
});

const contentStyles = xcss({
	maxWidth: '560px',
});

const gridStyles = xcss({
	display: 'grid',
	gridTemplateColumns: '2fr 8fr 2fr',
	gap: 'space.200',
});

const ContentContainer = ({ children }: { children: ReactNode }) => (
	<Box xcss={contentContainerStyles}>
		<Stack space="space.400" xcss={contentStyles}>
			{children}
		</Stack>
	</Box>
);

const Grid = ({ children }: { children: ReactNode }) => {
	return <Box xcss={gridStyles}>{children}</Box>;
};

export const WhatsNewArticle = ({ meta, content }: { meta: BlogMeta; content: ReactNode }) => {
	return (
		<HeadingContextProvider>
			{/* eslint-disable-next-line @atlassian/a11y/document-title -- VERIFIED: Description meta tag only, title provided elsewhere. */}
			<Helmet>{meta.canonicalUrl && <link rel="canonical" href={meta.canonicalUrl} />}</Helmet>

			<Inline alignInline="center">
				<Box xcss={pageContainerStyles}>
					<BlogBanner meta={meta} />
					<Box paddingBlockStart="space.800" paddingBlockEnd="space.300">
						<Grid>
							<div></div>
							<ContentContainer>
								<BlogHeader meta={meta} />
								<MDXBlogRenderer>{content}</MDXBlogRenderer>
							</ContentContainer>
							<Show above="sm">
								<LocalNav />
							</Show>
						</Grid>
					</Box>
				</Box>
			</Inline>
		</HeadingContextProvider>
	);
};
